import { useFetcher, useRevalidator } from '@remix-run/react';
import { Button, Modal, ModalBody, TextInput } from 'flowbite-react';
import { useEffect } from 'react';

interface StepUpModalProps {
    pendingScope: string;
    is2faEnabled: boolean;
    onSuccess?: () => void;
}

export function StepUpModal({ pendingScope, is2faEnabled, onSuccess }: StepUpModalProps) {
    const fetcher = useFetcher<{ ok?: boolean; error?: string }>();
    const revalidator = useRevalidator();

    useEffect(() => {
        if (fetcher.state === 'idle' && fetcher.data?.ok) {
            // notify orchestrator (if any) and refresh data
            onSuccess?.();
            revalidator.revalidate();
        }
    }, [ fetcher.state, fetcher.data, revalidator, onSuccess ]);

    const message = is2faEnabled ? 'Enter the current OTP to continue: ' : 'Enter the current password to continue: ';

    return (
        <Modal show={true} size='md'>
            <ModalBody>
                <h2 className='text-xl font-semibold mb-2 text-black dark:text-white'>Confirm it’s you</h2>
                <p className='text-sm mb-4 text-gray-600 dark:text-gray-300'>
                    {message}
                    <span className='font-medium'>{pendingScope}</span>
                </p>

                <fetcher.Form method='post' action='/verify-stepup'>
                    <input name='scope' type='hidden' value={pendingScope} />

                    {is2faEnabled
                        ? (
                            <TextInput
                                name='code'
                                inputMode='numeric'
                                pattern='[0-9]*'
                                placeholder='6-digit code'
                                autoFocus
                            />
                        )
                        : <TextInput name='password' type='password' placeholder='password' autoFocus />}

                    {fetcher.data?.error && (
                        <p className='mt-2 text-sm text-red-600 dark:text-red-400'>{fetcher.data.error}</p>
                    )}
                    <div className='mt-4 flex gap-3'>
                        <Button type='submit' name='intent' value='cancel' className='w-full cursor-pointer'>
                            Cancel
                        </Button>
                        <Button type='submit' name='intent' value='verify' className='w-full cursor-pointer'>
                            Verify
                        </Button>
                    </div>
                </fetcher.Form>
            </ModalBody>
        </Modal>
    );
}
